import { Component, OnInit } from "@angular/core";
import { NbSidebarService } from "@nebular/theme";
import { environment } from "../../environments/environment";
import { ProfileService } from "./services/profile.service";
import { Event, NavigationEnd, Router } from "@angular/router";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  constructor(
    private sidebarService: NbSidebarService,
    private profile: ProfileService,
    private router: Router
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (window.innerWidth <= 768)
          this.sidebarService.collapse();
      }
    });    
  }

  logo: string = environment.logo;
  logo_width: number = environment.inner_logo_width;
  name: string = "Client";
  items = [
    { title: "Change Password", link: ["/dashboard/profile/change-password"] },
    { title: "Logout", link: ["/dashboard/logout"] },
  ];

  sidebar_items = [
    {
      title: "Dashboard",
      icon: "keypad-outline",
      link: ["/dashboard"],
    },
    {
      title: "Profile",
      icon: "person-outline",
      link: ["/dashboard/profile"],
    },
    {
      title: "Documents",
      link: ["/dashboard/documents"],
      icon: "archive-outline",
    },
    {
      title: "Trade Accounts",
      link: [],
      icon: "grid-outline",
      children: [
        {
          title: "Demo account",
          link: ["/dashboard/accounts/demo"],
          icon: "chevron-right-outline",
        },
        {
          title: "Live account",
          link: ["/dashboard/accounts/live"],
          icon: "chevron-right-outline",
        },
      ],
    },
    {
      title: "Deposit",
      link: ["/dashboard/finance/deposit"],
      icon: "download-outline",
    },
    {
      title: "Withdraw",
      link: ["/dashboard/finance/withdraw"],
      icon: "upload-outline",
    },
    {
      title: "Bank Account",
      link: ["/dashboard/user-bank-account"],
      icon: "npm-outline",
    },    
    // {
    //   title: "Internal-Transfer",
    //   link: ["/dashboard/finance/internal-transfer"],
    //   icon: "swap-outline",
    // },
    {
      title: "Report",
      link: [],
      icon: "credit-card-outline",
      children: [
        {
          title: "Deposit-Report",
          link: ["/dashboard/finance/deposit-report"],
          icon: "chevron-right-outline",
        },
        {
          title: "Withdraw-Report",
          link: ["/dashboard/finance/withdraw-report"],
          icon: "chevron-right-outline",
        },
        {
          title: "Internal-Transfer-Report",
          link: ["/dashboard/finance/internal-transfer-report"],
          icon: "chevron-right-outline",
        },
      ],
    },
    {
      title: "Logout",
      link: ["/dashboard/logout"],
      icon: "log-out-outline",
    },
  ];

  ngOnInit() {
    this.profile.userInfoBasic().subscribe((response) => {
      if (response.request_status) {
        this.name = response.data.fullname;
      }
    });
  }

  toggle() {
    this.sidebarService.toggle(true);
    return false;
  }
}
